<div [formGroup]="form">
	<nz-form-item *ngIf="inline == false">
		<nz-form-label *ngIf="span != 0" [nzSpan]="span" [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>
		<nz-form-label *ngIf="span == 0" [nzRequired]="wrapper.element.required">{{ wrapper.element.name }}</nz-form-label>


		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<nz-select [formControlName]="toControlKey(wrapper.element)" nzPlaceHolder="Select an option"  [nzDisabled]="readonly">
				<nz-option *ngFor="let opt of wrapper.element.options"
				[nzValue]="opt.value"
				[nzLabel]="opt.label"
				nzCustomContent>
					{{ opt.label }}
					<ng-container *ngIf="opt.tag">
						<nz-tag *ngIf="opt.tag == 'Unverified'" nzColor="default" class="float-end">{{ opt.tag }}</nz-tag>
						<nz-tag *ngIf="opt.tag == 'Deceased'" nzColor="warning" class="float-end">{{ opt.tag }}</nz-tag>
						<nz-tag *ngIf="opt.tag == 'Living'" nzColor="success" class="float-end">{{ opt.tag }}</nz-tag>
						<nz-tag *ngIf="opt.tag == 'Error'" nzColor="error" class="float-end">{{ opt.tag }}</nz-tag>
					</ng-container>
				</nz-option>
			</nz-select>
		</nz-form-control>
	</nz-form-item>
	<nz-form-item *ngIf="inline == true">
		<nz-form-control [nzAutoTips]="wrapper.autoTips">
			<nz-select [formControlName]="toControlKey(wrapper.element)" nzPlaceHolder="Select an option"  [nzDisabled]="readonly">
				<nz-option *ngFor="let opt of wrapper.element.options"
				[nzValue]="opt.value"
				[nzLabel]="opt.label"
				nzCustomContent>
					{{ opt.label }}
					<ng-container *ngIf="opt.tag">
						<nz-tag *ngIf="opt.tag == 'Unverified'" nzColor="default" style="margin-left: 8px;">{{ opt.tag }}</nz-tag>
						<nz-tag *ngIf="opt.tag == 'Deceased'" nzColor="warning" style="margin-left: 8px;">{{ opt.tag }}</nz-tag>
						<nz-tag *ngIf="opt.tag == 'Living'" nzColor="success" style="margin-left: 8px;">{{ opt.tag }}</nz-tag>
						<nz-tag *ngIf="opt.tag == 'Error'" nzColor="error" style="margin-left: 8px;">{{ opt.tag }}</nz-tag>
					</ng-container>
				</nz-option>
			</nz-select>
		</nz-form-control>
	</nz-form-item>
</div>
